import { createSelector, createReducer } from '@reduxjs/toolkit';
import { COMMENTSTATUS_INCLUDE } from '../../constants/api';
import {
  getAllCommentsForHearingSuccess,
  getPaginatedCommentsForHearingSuccess,
} from '../actions/api';
import { getEntityId } from '../helpers/apiHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';

import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------

// CommentStatus is included in the following endpoints
//  - GET /hearing/{hearingId}/comment

// -------- Reducer --------
const commentStatusReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const commentStatus = data.filter(
          (include) => include.type === COMMENTSTATUS_INCLUDE,
        );
        return updateDtoList(state, 'all', commentStatus);
      })
      .addCase(getPaginatedCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const commentStatus = data.filter(
          (include) => include.type === COMMENTSTATUS_INCLUDE,
        );
        return updateDtoList(state, 'all', commentStatus);
      });
  },
);

// -------- Selectors --------
const selectGetAllCommentStatus = (state) =>
  selectAllFromApiState(state, 'commentStatus');
const allCommentStatusSelector = createSelector(
  selectGetAllCommentStatus,
  (commentStatus) => commentStatus,
);
const commentStatusByIdSelector = (commentStatusId) =>
  createSelector(selectGetAllCommentStatus, (commentStatus) =>
    commentStatus.find((status) => getEntityId(status) === commentStatusId),
  );

// -------- Exporting --------
export { allCommentStatusSelector, commentStatusByIdSelector };
export default commentStatusReducer;
